module.exports = __webpack_public_path__ + "img/12.a57060e1.png";